import { render, staticRenderFns } from "./CardInteligenciaTerritorialPotencialAgropecuario.vue?vue&type=template&id=9e871190&scoped=true&lang=pug"
import script from "./CardInteligenciaTerritorialPotencialAgropecuario.vue?vue&type=script&lang=js"
export * from "./CardInteligenciaTerritorialPotencialAgropecuario.vue?vue&type=script&lang=js"
import style0 from "./CardInteligenciaTerritorialPotencialAgropecuario.vue?vue&type=style&index=0&id=9e871190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e871190",
  null
  
)

export default component.exports